import React from 'react'
import High from './High'
import Low from './Low'
import ShouldBeRunning from './ShouldBeRunning'

const Battery = ({ color, disconnected, high, low, style }) => {
  const defaultStyle = { fill: color }
  const svgStyle = { ...defaultStyle, ...style }

  return (
    <svg
      style={svgStyle}
      viewBox='0 0 75 75'
    >
      <description>battery icon</description>
      <title>battery</title>
      <g
        style={{
          transform: 'translate(13px, 12px) scale(.3)',
        }}
      >
        <path
          d='M118.8,28.4v-7.1h16.8v7.1h28.1c0,2,0,7.2,0,9.2H0c0-2,0-7.2,0-9.2h30.7v-7.1h16.8v7.1H118.8L118.8,28.4z
          M105.8,51.7L86.9,81.3l12.7-4l-41.7,56.8l20.2-40.9l-14,4.9l19.4-35.7L105.8,51.7L105.8,51.7z M156,41.6H7.7c0,34.5,0,69,0,103.5
          H156C156,110.6,156,76.1,156,41.6L156,41.6z M123.3,74.4v-7.1h-7.2v-4.9h7.2v-7.1h4.8v7.1h7.2v4.9h-7.2v7.1H123.3L123.3,74.4z
          M28.4,67.4v-5.3h14.9v5.3H28.4z'
        />
      </g>

      {!!high && (
        <g id='high' transform='translate(40,40) scale(.4)'>
          <High />
        </g>
      )}

      {!!low && (
        <g id='low' transform='translate(40,40) scale(.4)'>
          <Low />
        </g>
      )}

      {!!disconnected && (
        <g id='should-be-running' transform='translate(40,40),scale(.4)'>
          <ShouldBeRunning />
        </g>
      )}
    </svg>
  )
}

const BatteryDefault = ({ color = '#284047', disconnected, high, low, style }) => (<Battery color={color} disconnected={disconnected} high={high} low={low} style={style} />)

export default BatteryDefault
